import React from "react";
import { useRouter } from "next/router";
import { redirectBackUrl } from "utils/method";
import getCommonStaticProps from "@xt/ssg";
import LayoutXt from "components/Layout/xt";
import LayoutAuth from "components/Layout/Auth";
import Login from "components/Pages/Login";
import Seo from "components/Seo";
import useIsDesktop from "@/hooks/useIsDesktop";

export default function PageLogin({ locale, tdk, resolvedUrl }) {
  const router = useRouter();
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  const onAuthError = () => {
    redirectBackUrl(router);
  };

  return (
    <>
      <Seo tdk={tdk} resolvedUrl={resolvedUrl} locale={locale} />
      <LayoutXt mobileNav="logoLang" isShowFoot={isSpikexPc} useSiteFooter={isSpikexPc}>
        <LayoutAuth needLogin={false} onAuthError={onAuthError}>
          <Login />
        </LayoutAuth>
      </LayoutXt>
    </>
  );
}

export const getStaticProps = (context) => getCommonStaticProps(context, "/accounts/login", { zE_show: true });
